var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "100%",
      showRequiredFields: false,
      showButton: false,
    },
    on: {
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              { attrs: { fluid: "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _vm.loading
                          ? _c("v-progress-linear", {
                              attrs: {
                                indeterminate: "",
                                color: "cyan lighten-4",
                              },
                            })
                          : _vm._e(),
                        _c("v-data-table", {
                          staticClass: "elevation-1",
                          attrs: {
                            items: _vm.items,
                            headers: _vm.headers.filter((h) => h.visible),
                            "sort-by": "calories",
                            "item-key": "index",
                            "hide-default-footer": true,
                            "items-per-page": -1,
                            "fixed-header": "",
                            height: "400",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }